export default [
    {
		path: '/member/:id/:tab?/:subtab?/:idForAction?/:action?',
		name: 'Workspace Member',
		component: () => import('@/views/team/member/WorkspaceMember.vue'),
		props: true,
		meta: {
			layout: 'Default',
			abilities: [['view', 'workspace-schedules'], ['manage', 'my-profile'], ['manage', 'workspace-member-settings']],
			ownerIdParameter: 'id',
			nav: 'workspace',
		}
	},
	{
		path: '/workspace',
		name: 'Workspace',
		component: () => import('@/views/team/Workspace.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'workspace-members']],
			nav: 'workspace',
		}
	},
	{
		path: '/workspace/refresh',
		name: 'Workspace Refresh',
		component: () => import('@/views/team/Workspace.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-members']],
		}
	},
	{
		path: '/workspace/invited',
		name: 'Workspace Invite',
		component: () => import('@/views/team/WorkspaceInviteView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'invitations']],
			nav: 'workspace',
		}
	},
    {
		path: '/workspace/settings',
		name: 'Workspace Settings',
		component: () => import('@/views/account/AccountView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
		}
	},
	{
		path: '/workspace/settings/pixel',
		name: 'Workspace Settings Add Pixel',
		component: () => import('@/views/account/AccountAddPixel.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
		}
	},
	{
		path: '/workspace/settings/add',
		name: 'Workspace Settings Add Workspace',
		component: () => import('@/views/account/AccountAddWorkspace.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'workspace-settings']],
			nav: 'workspace',
		}
	},
]